<template>
  <div class="flex flex-col gap-y-6 w-full max-h-[680px] delete-image-dialog">
    <Heading level="h4">{{ I18n.t("editor.delete_image_dialog.header") }}</Heading>
    <p>{{ I18n.t("editor.delete_image_dialog.body") }}</p>
    <div class="sm:flex sm:flex-row-reverse sm:gap-x-3 space-y-3 sm:space-y-0 grow">
      <Button class="delete-image-dialog-button mb-2" fullWidth type="submit" @click.prevent="handleDelete"
        >{{ I18n.t("editor.delete") }}
        <template #start>
          <TrashIcon />
        </template>
      </Button>
      <Button fullWidth autofocus variant="secondary" type="reset" @click="handleCancel">
        {{ I18n.t("editor.cancel") }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button, Heading, TrashIcon } from "prism";

interface Props {
  onDelete: () => void;
  onCancel: () => void;
}

const props = defineProps<Props>();

const handleDelete = () => {
  props.onDelete();
};

const handleCancel = () => {
  props.onCancel();
};
</script>

<style scoped lang="scss">
.delete-image-dialog-button {
  background-color: #dd2d00 !important;
  &:hover {
    background-color: #c62801 !important;
  }
}

.delete-image-dialog {
  width: 480px !important;
  max-width: 480px !important;
  max-height: 680px !important;
}
</style>
